(ns common.trie)

(defn add-to-trie [break-set escaped? trie [k & ks]]
  (if (= k \/)
    (add-to-trie break-set true trie ks)
    (let [break? (and (break-set k) (not escaped?))
          node (if break? {:break true} {})
          trie (if break? (assoc trie :terminal true) trie)]
      (if ks
        (assoc trie k (add-to-trie break-set false (get trie k node) ks))
        (assoc trie k (assoc node :terminal true))))))

(defn build-trie
  ([coll] (build-trie coll #{}))
  ([coll break-set] (reduce (partial add-to-trie break-set false) {} coll)))

(defn- traverse
  [result path node]
  (concat
   result
   (when (:terminal node) [path])
   (mapcat (fn [[k v]]
             (when (and (map? v) (not (:break v)))
               (traverse [] (conj path k) v)))
           node)))

(defn- find-node
  [prefix node path]
  (let [[head & tail] prefix
        next (node head)
        path (if (:break next) [] (conj path head))]
    (cond
      (nil? next) nil
      (empty? tail) {:node next :path path}
      :else (find-node tail next path))))

(defn prefix-matches
  [prefix trie]
  (let [{:keys [node path]} (if (seq prefix)
                              (find-node prefix trie [])
                              {:node trie :path []})]
    (map #(apply str %) (traverse [] path node))))
